import { render, staticRenderFns } from "./RegisteredApplications.vue?vue&type=template&id=5ecf1fc7&"
import script from "./RegisteredApplications.vue?vue&type=script&lang=js&"
export * from "./RegisteredApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports